import React from 'react';
import { Badge } from './ui/badge';

/**
 * Bold section heading used across all public modules.
 * Renders an eyebrow badge, big serif H2 with a gradient accent on the highlighted word,
 * a subtitle, and a decorative gradient bar underneath.
 */
export const SectionHeading = ({ eyebrow, title, accent, subtitle, align = 'center' }) => {
  return (
    <div className={`mb-12 md:mb-16 ${align === 'center' ? 'text-center' : 'text-left'}`}>
      {eyebrow && (
        <Badge className="mb-4 bg-gradient-to-r from-amber-100 to-orange-100 text-orange-700 border-orange-200 px-3 py-1 text-xs font-semibold uppercase tracking-widest">
          {eyebrow}
        </Badge>
      )}
      <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-[#0A1628] mb-4 leading-tight">
        {title}{' '}
        {accent && (
          <span className="italic bg-gradient-to-r from-amber-500 via-orange-500 to-rose-500 bg-clip-text text-transparent">
            {accent}
          </span>
        )}
      </h2>
      <div className={`h-1.5 w-24 bg-gradient-to-r from-amber-400 via-orange-500 to-rose-500 rounded-full ${align === 'center' ? 'mx-auto' : ''} mb-4`}></div>
      {subtitle && (
        <p className="text-base md:text-lg text-gray-600 max-w-3xl leading-relaxed mx-auto">{subtitle}</p>
      )}
    </div>
  );
};

export default SectionHeading;
